// Define types locally to avoid importing from client hooks
export type QuickSearchSortOption = 'RELEVANCE' | 'PRICE_ASC' | 'PRICE_DESC' | 'DATE_ADDED_ASC' | 'DATE_ADDED_DESC'
export type QuickSearchFilterOption = 'IN_STOCK' | 'ON_SALE'

export const FILTER_OPTIONS = [
  { id: 'IN_STOCK', name: 'In stock' },
  { id: 'ON_SALE', name: 'On sale' },
] as const

export const ITEMS_PER_PAGE = 25

// Sort options using QuickSearchSortOption keys for consistency
export const sortOptions = {
  RELEVANCE: 'RELEVANCE',
  PRICE_LOW_TO_HIGH: 'PRICE_ASC',
  PRICE_HIGH_TO_LOW: 'PRICE_DESC',
  DATE_ADDED_NEW_TO_OLD: 'DATE_ADDED_DESC',
  DATE_ADDED_OLD_TO_NEW: 'DATE_ADDED_ASC',
} as const

// Helper to get display names for sort options
export const sortOptionLabels: Record<QuickSearchSortOption, string> = {
  RELEVANCE: 'Relevance',
  PRICE_ASC: 'Price (Low to High)',
  PRICE_DESC: 'Price (High to Low)',
  DATE_ADDED_ASC: 'Date Added (Oldest First)',
  DATE_ADDED_DESC: 'Date Added (Newest First)',
}